import TEMPLATE_URL from "emun.cart/cart-item-picker/cart-item-picker.htm";
import controller from "emun.cart/cart-item-picker/cart-item-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "lg",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Choose product...",
	subTitle = "Choose product for discount",
	single = false,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	onToggle = NOOP,
	onProductSelected = NOOP,
	onProductDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onProductSelected,
				onProductDeselected,
				onToggle,
				okButtonText,
				closeButtonText
			})
		}
	}).result;
